import React from 'react';

function PieChart(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M13.25 2.625C12.9048 2.625 12.625 2.90482 12.625 3.25V10.75C12.625 11.0952 12.9048 11.375 13.25 11.375H20.75C21.0952 11.375 21.375 11.0952 21.375 10.75C21.375 6.26232 17.7377 2.625 13.25 2.625ZM13.875 3.903L13.953 3.91049C17.1889 4.23905 19.7609 6.81112 20.0895 10.047L20.096 10.125H13.875V3.903Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M10.75 5.125C6.26232 5.125 2.625 8.76232 2.625 13.25C2.625 17.7377 6.26232 21.375 10.75 21.375C15.2377 21.375 18.875 17.7377 18.875 13.25L18.8682 13.1576C18.8236 12.8563 18.5638 12.625 18.25 12.625H11.375V5.75C11.375 5.40482 11.0952 5.125 10.75 5.125ZM10.125 6.403V13.25L10.1318 13.3424C10.1764 13.6437 10.4362 13.875 10.75 13.875H17.596L17.5895 13.953C17.2375 17.42 14.31 20.125 10.75 20.125C6.95268 20.125 3.875 17.0473 3.875 13.25C3.875 9.69001 6.57999 6.76252 10.047 6.41049L10.125 6.403Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default PieChart;
